import { mainButton, miniApp } from '@telegram-apps/sdk-react';

type Scheme = 'dark' | 'light';

/** index.css dagi brend tokenlari — Telegram'ning o'z elementlari (header, fon, MainButton) uchun. */
export const BRAND_COLORS = {
  dark: { bg: '#07090d', lime: '#c6ff3d', limeInk: '#0b0f14' },
  light: { bg: '#f4f1ea', lime: '#b6f22a', limeInk: '#0b0f14' },
} as const satisfies Record<Scheme, Record<string, `#${string}`>>;

let current: Scheme = 'dark';
export const currentScheme = () => current;

const safe = (fn: () => void) => {
  try {
    fn();
  } catch (e) {
    console.error('[theme]', e);
  }
};

/** MainButton — brend lime (native tugma ham ilova bilan bir xil). */
export function brandMainButtonColors() {
  const c = BRAND_COLORS[current];
  return { backgroundColor: c.lime, textColor: c.limeInk };
}

function apply(scheme: Scheme) {
  current = scheme;
  document.documentElement.dataset.theme = scheme;
  const { bg } = BRAND_COLORS[scheme];
  safe(() => {
    if (miniApp.setHeaderColor.isAvailable() && miniApp.setHeaderColor.supports.rgb())
      miniApp.setHeaderColor(bg);
  });
  safe(() => miniApp.setBackgroundColor.ifAvailable(bg));
  safe(() => miniApp.setBottomBarColor.ifAvailable(bg));
  safe(() => {
    if (mainButton.isMounted()) mainButton.setParams(brandMainButtonColors());
  });
}

/**
 * Tema: Telegram ichida — foydalanuvchining Telegram temasi qorong'imi (`miniApp.isDark`),
 * tashqarida (dev brauzer) — `prefers-color-scheme`. Ranglar har doim brend palitrasidan.
 */
export function initTheme(): void {
  if (miniApp.isMounted()) {
    apply(miniApp.isDark() ? 'dark' : 'light');
    miniApp.isDark.sub((dark) => apply(dark ? 'dark' : 'light'));
    return;
  }
  const mq = window.matchMedia('(prefers-color-scheme: dark)');
  apply(mq.matches ? 'dark' : 'light');
  mq.addEventListener('change', (e) => apply(e.matches ? 'dark' : 'light'));
}
